import { useState } from "react";
import { Check } from "lucide-react";

export const usd = (n) => (n === null || n === undefined ? "—" : `US$ ${Number(n).toLocaleString("es-PY", { maximumFractionDigits: 0 })}`);
export const pct = (n) => (n === null || n === undefined ? "—" : `${Math.round(n)}%`);
const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "set", "oct", "nov", "dic"];
export const mesCorto = (p) => (p ? MESES[Number(p.slice(5, 7)) - 1] : "");
export const mesLargo = (p) => (p ? ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "setiembre", "octubre", "noviembre", "diciembre"][Number(p.slice(5, 7)) - 1] : "");
export const clasePts = (p) => (p === null || p === undefined ? "g" : p >= 85 ? "v" : p >= 70 ? "a" : "r");
export const fmtFecha = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "—");

export const Cobranza = ({ s }) => {
  const [sel, setSel] = useState(null);
  const serie = s.serie_cobros || [], max = Math.max(1, ...serie.map((x) => x.monto)), actual = serie[serie.length - 1]?.mes;
  return (
    <div className="dp-card" data-testid="dp-cobranza">
      <h3>Cobranza</h3>
      <div className="dp-big num">{usd(s.promedio_6m)}</div><div className="dp-sec">promedio mensual · 6 meses</div>
      <div className="dp-lolli">
        {serie.map((x) => (
          <button key={x.mes} className={`${x.mes === actual ? "actual" : ""} ${sel === x.mes ? "sel" : ""}`} onClick={() => setSel(sel === x.mes ? null : x.mes)} data-testid={`dp-mes-${x.mes}`} aria-label={`${mesCorto(x.mes)} ${usd(x.monto)}`}>
            <span className="palo" style={{ height: `${Math.max(6, (x.monto / max) * 80)}px` }} /><span className="punto" /><small>{mesCorto(x.mes)}</small>
          </button>
        ))}
      </div>
      {sel && <span className="dp-monto num" data-testid="dp-mes-monto">{mesCorto(sel)}: {usd(serie.find((x) => x.mes === sel)?.monto)}</span>}
    </div>
  );
};

const Ring = ({ r, color, p }) => { const c = 2 * Math.PI * r; if (!p) return null; return <circle cx="75" cy="75" r={r} fill="none" stroke={color} strokeWidth="11" strokeLinecap="round" strokeDasharray={`${(Math.min(100, p ?? 0) / 100) * c} ${c}`} transform="rotate(-90 75 75)" />; };

export const Meta = ({ s, mes }) => {
  const m = s.meta || {};
  const filas = [["#007336", "Cobros", `${usd(s.cobrado_mes)} de ${usd(m.meta)}`, s.cobros_pct], ["#5FA8D9", "Pagarés recuperados", "sin fecha de firma en los datos", s.pagares_pct], ["#8B5E3C", "Documentos al día", `${s.docs_ok} de ${s.docs_total} clientes`, s.docs_pct]];
  return (
    <div className="dp-card" data-testid="dp-meta">
      <h3>Meta del mes</h3>
      <div className="dp-anillos">
        <svg width="150" height="150" viewBox="0 0 150 150">
          {[[66, "#E9F0E7"], [52, "#E9F0E7"], [38, "#E9F0E7"]].map(([r, c]) => <circle key={r} cx="75" cy="75" r={r} fill="none" stroke={c} strokeWidth="11" />)}
          <Ring r={66} color="#007336" p={s.cobros_pct} /><Ring r={52} color="#5FA8D9" p={s.pagares_pct} /><Ring r={38} color="#8B5E3C" p={s.docs_pct} />
          <text x="75" y="82" textAnchor="middle" fontSize="24" fontWeight="600" fill="#24331F" data-testid="dp-puntaje">{s.puntaje === null || s.puntaje === undefined ? "—" : Math.round(s.puntaje)}</text>
        </svg>
        <div>
          <span className={`dp-chip ${clasePts(s.puntaje)}`} data-testid="dp-nivel">{s.nivel}</span>
          <p className="dp-sec" style={{ marginTop: 10 }}>Meta de cobro: vence en {mesLargo(mes)} <b className="num" style={{ color: "#24331F" }}>{usd(m.vence_mes)}</b> + vencido <b className="num" style={{ color: "#24331F" }}>{usd(m.vencido)}</b></p>
        </div>
      </div>
      <div style={{ marginTop: 14 }}>
        {filas.map(([c, t, d, p]) => <div className="dp-ley" key={t}><i style={{ background: c }} /><span>{t}<span className="d"> · {d}</span></span><b className="num">{pct(p)}</b></div>)}
      </div>
    </div>
  );
};

export const Pendientes = ({ items, onToggle }) => {
  const hechos = items.filter((i) => i.hecho).length;
  return (
    <div className="dp-card dp-negra" data-testid="dp-pendientes">
      <h3>Pendientes</h3>
      <div className="cont num">{hechos}<span> / {items.length} hechos</span></div>
      <div className="riel"><i style={{ width: `${items.length ? (hechos / items.length) * 100 : 0}%` }} /></div>
      {items.length === 0 && <p className="dp-sec" style={{ color: "#A9B8A5" }}>Sin pendientes automáticos.</p>}
      {items.map((p) => (
        <button key={p.clave} className="dp-pend" role="checkbox" aria-checked={p.hecho} onClick={() => onToggle(p)} data-testid={`dp-pend-${p.clave}`}>
          <span className="c">{p.hecho && <Check className="h-4 w-4" />}</span>
          <span><div className="t">{p.texto}</div><div className="d">{p.detalle}</div></span>
        </button>
      ))}
    </div>
  );
};

const AG_COL = ["#007336", "#D9B65C", "#A9784A", "#7A4E2D", "#B8402A"];
export const Antiguedad = ({ s }) => (
  <div className="dp-card" data-testid="dp-antiguedad">
    <h3>Antigüedad de la deuda</h3>
    <div className="dp-seg">{(s.aging || []).map((a, i) => <span key={a.clave} style={{ width: `${a.pct}%`, background: AG_COL[i], minWidth: a.pct ? 6 : 0 }}>{a.pct >= 8 ? `${Math.round(a.pct)}%` : ""}</span>)}</div>
    <div className="dp-seg-m">{(s.aging || []).map((a) => <div key={a.clave}>{a.etiqueta}<b className="num">{usd(a.monto)}</b></div>)}</div>
    <div style={{ marginTop: 14 }}>
      {(s.top_vencidos || []).length === 0 && <p className="dp-sec">Sin clientes con vencido.</p>}
      {(s.top_vencidos || []).map((t) => (
        <div className="dp-top" key={t.cliente}><div className="dias">{t.dias ?? "—"}<small>días</small></div><div className="truncate font-semibold">{t.cliente}</div><b className="num">{usd(t.vencido)}</b></div>
      ))}
    </div>
  </div>
);

export const Ranking = ({ equipo, sel, onSel }) => (
  <div className="dp-card dp-rank" data-testid="dp-ranking">
    <h3>Ranking del mes</h3>
    <table>
      <thead><tr><th>#</th><th>Vendedor</th><th>Cartera</th><th>Cobrado</th><th>Meta del mes</th><th>Vencido %</th><th>Docs %</th><th>6 meses</th></tr></thead>
      <tbody>
        {equipo.map((e, i) => {
          const mx = Math.max(1, ...e.serie_cobros.map((x) => x.monto));
          return (
            <tr key={e.vendedor} className="fila" aria-selected={sel === e.vendedor} onClick={() => onSel(e.vendedor)} data-testid={`dp-rank-${i}`}>
              <td className="num">{i + 1}</td><td className="font-semibold">{e.vendedor}</td><td className="num">{usd(e.cartera)}</td><td className="num">{usd(e.cobrado_mes)}</td>
              <td><span className="barra"><i style={{ width: `${e.cobros_pct ?? 0}%` }} /></span><span className="num">{pct(e.cobros_pct)}</span></td>
              <td className={`num ${(e.vencido_pct ?? 0) >= 30 ? "dp-rojo" : ""}`}>{pct(e.vencido_pct)}</td><td className="num">{pct(e.docs_pct)}</td>
              <td><span className="mini">{e.serie_cobros.map((x) => <i key={x.mes} style={{ height: `${Math.max(2, (x.monto / mx) * 22)}px` }} />)}</span></td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
